import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CadCadastroAnexoOnline } from '../interfaces/cad-cadastro-anexo-online';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CadCadastroAnexoOnlineService {

  readonly path = '/cadastro/anexo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getCadCadastroAnexo(id: number, generatePresignedUrl = false){
    return this.http.get<CadCadastroAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${id}?generatePresignedUrl=${generatePresignedUrl}`); 
  }


  getCadCadastroAnexoOnlinePage(cadastroId: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<CadCadastroAnexoOnline>> {
    return this.http.get<PageResult<CadCadastroAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?page=${page}&size=${size}&cadastroId=${cadastroId}&order=${order}&direction=${direction}`);
  }

  getCadCadastroAnexoOnlinePageSearch(search:string, cadastroId: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<CadCadastroAnexoOnline>> {
    return this.http.get<PageResult<CadCadastroAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?search=${search}&page=${page}&size=${size}&cadastroId=${cadastroId}&order=${order}&direction=${direction}`);
  }

  downloadAnexo(anexoId: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/download/${anexoId}`
    , {responseType: 'arraybuffer'});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}

